module.exports = __webpack_public_path__ + "img/hnpn.d61fdbc2.png";